import {Action} from '@ngrx/store';
import {IBreadcrumbState} from '../state/breadcrumb.state';

export enum BREADCRUMB_ACTION {
  INIT_BREADCRUMB = 'INIT_BREADCRUMB',
  RESET_BREADCRUMB = 'RESET_BREADCRUMB',
}

export class SetBreadcrumb implements Action {
  readonly type: BREADCRUMB_ACTION.INIT_BREADCRUMB = BREADCRUMB_ACTION.INIT_BREADCRUMB;

  constructor(public payload: IBreadcrumbState) {}
}
// eslint-disable-next-line max-classes-per-file
export class ResetBreadcrumb implements Action {
  readonly type = BREADCRUMB_ACTION.RESET_BREADCRUMB;
}
export type BreadcrumbAction = SetBreadcrumb | ResetBreadcrumb;
